<template>
  <div id="Cooperation" v-if="this.ppadmin_data">
    <div v-html="cooperation" class="content container"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CooperationView",
  computed: {
    ...mapState("headerNav", ["ppadmin_data"]),
    cooperation() {
      return this.ppadmin_data[6].data;
    },
  },
};
</script>

<style lang="less" scoped>
* {
  list-style: unset;
  margin: unset;
  padding: unset;
}
#Cooperation {
  ::v-deep .content {
    img {
      width: 100% !important;
    }
  }
}
</style>
